import React from "react";
import { COLORS } from "../../constants/colors";
import { FaExclamation } from "react-icons/fa6";
import { MdOutlineRefresh } from "react-icons/md";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null,
            isReloading: false
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }
    
    componentDidCatch(error, errorInfo) {
        // Log to external service (Sentry, LogRocket, etc.)
        console.error("ErrorBoundary caught an error:", error, errorInfo);
        this.setState({
            error,
            errorInfo,
        });
    }

    handleReload = () => {
        this.setState({ isReloading: true });
        setTimeout(() => {
            window.location.reload();
        }, 2000); // 1 sec animation
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="flex flex-col items-center justify-center min-h-screen text-center px-4">
                    <span className="bg-red-600 p-2 mb-2 text-white rounded-full">
                        <FaExclamation size={30} />
                    </span>
                    <h2 className={`text-2xl md:text-4xl font-semibold text-[${COLORS.TxtPrimary}]`}>
                        Something went wrong
                    </h2>
                    <p className="text-gray-600 mt-2 max-w-md">
                        An unexpected error occurred. Please try refreshing the page or come back later.
                    </p>

                    <button
                        onClick={this.handleReload}
                        className={`mt-4 px-4 py-2 bg-[${COLORS.TxtSecondary}] flex gap-1 items-center text-white rounded-sm hover:scale-[0.98] font-medium transition-all duration-300 transition hover:bg-[#0f5f7b]`}
                    >
                        <MdOutlineRefresh size={22} className={`${this.state.isReloading ? "animate-spin" : ""}`} />  Try again
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;